// extracted by mini-css-extract-plugin
module.exports = {"button":"UploadTrigger_button__37GuK"};